import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { adminMenuItems, groupMenuItems } from '../../components/admin/adminMenu';

// Every section of the panel as large buttons, easy to tap on a phone or tablet.
const MenuMoviles: React.FC = () => {
  const { user } = useAuth();
  const groups = groupMenuItems(adminMenuItems(user).filter((item) => item.path !== '/admin/moviles'));
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">Móviles/Tablet</h1>
        <p className="text-sm text-gray-600">Todas las secciones en botones grandes, para usar desde el celular o la tablet.</p>
      </div>
      {groups.map((group) => (
        <section key={group.title || 'inicio'}>
          {group.title && <h2 className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">{group.title}</h2>}
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {group.items.map(({ path, label, Icon }) => (
              <Link key={path} to={path === '/admin/seguridad' ? '/admin/seguridad/resumen' : path}
                className="flex min-h-[6.5rem] flex-col items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-4 text-center text-sm font-semibold leading-tight text-slate-800 shadow-sm transition-colors hover:border-primary-300 hover:bg-primary-50 active:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-primary-300">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-50 text-primary-700"><Icon className="h-6 w-6" /></span>
                {label}
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default MenuMoviles;
